// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"16e1aeea","229":"84f17f2a","239":"e253d81b","306":"89462fc8","403":"5cedde20","475":"abdd8e47","479":"0b763e7a","563":"d8c1cbf8","639":"e0fc327c","977":"f4eefdf2"}[chunkId] + ".chunk.js";
};